import { render } from "./HeroiconsSolidVolumeOff.vue?vue&type=template&id=7cad67c0"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidVolumeOff.vue"]])

export default __exports__